import { Collapse } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye } from '@fortawesome/free-solid-svg-icons'
import { WrapperLateral } from './styled'

interface PropsLateral {
    analises: any[]
    atualizarCoresDosPontos: Function
    selecionado: number
    setSelecionado: React.Dispatch<React.SetStateAction<number>>
}

export const LateralVerAnalises: React.FC<PropsLateral> = ({
    analises,
    atualizarCoresDosPontos,
    selecionado,
    setSelecionado
}) => {
    const { Panel } = Collapse

    return (
        <WrapperLateral>
            <h3 className='lateral__title'>Análises cadastradas</h3>
            <Collapse accordion>
                {analises.map((item, index) => (
                    <Panel
                        key={item?.id ?? index}
                        header={
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    gap: 5,
                                    // permite o rótulo encolher e aplicar ellipsis em nomes longos
                                    minWidth: 0,
                                }}
                            >
                                {/* Análise + profundidade: só a profundidade repetia entre painéis
                                (a mesma faixa pode ter várias análises), deixando itens
                                visualmente idênticos. */}
                                <span className='lateral__rotulo'>
                                    <span className='lateral__rotulo__analise'>{item?.analise_nome}</span>
                                    <span className='lateral__rotulo__separador'>|</span>
                                    <span className='lateral__rotulo__profundidade'>{item?.profundidade}</span>
                                </span>
                                <div
                                    className='button__eye'
                                    style={
                                        {
                                            '--cor-do-item': item?.cor,
                                        } as React.CSSProperties
                                    }
                                    onClick={(e) => { e.stopPropagation(); atualizarCoresDosPontos(item) }}
                                    data-active={item?.id === selecionado}
                                >
                                    <FontAwesomeIcon icon={faEye} fontSize={13} />
                                </div>
                            </div>
                        }
                    >
                        <div className='container__adicionados'>
                            {/* O nome da análise saiu daqui para o header do painel. */}
                            <h3 className='points-title'>Pontos</h3>

                            <div className='points-grid'>
                                {item?.pontos_selecionados?.map((point, index) => (
                                    <div
                                        key={index}
                                        className='point-card'
                                        style={
                                            {
                                                '--cor-do-item': point?.COR,
                                            } as React.CSSProperties
                                        }
                                    >
                                        {point?.NOME.toString().padStart(2, '0')}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </Panel>
                ))}
            </Collapse>
        </WrapperLateral>
    )
}
